import { JOBS } from "../Action";

const HeaderData = [
  {
    name: "Unique ID",
    direction: "asc",
    sort: false,
    minWidth: "100px",
  },
  {
    name: "Req ID",
    direction: "asc",
    defaultDirection: "asc",
    sort: true,
    active: false,
    key: "req_id.keyword",
  },
  {
    name: "Title",
    direction: "asc",
    defaultDirection: "asc",
    sort: true,
    active: false,
    key: "job_title.keyword",
  },
  { name: "Status", direction: "asc", sort: false },
  {
    name: "Compensation (Hourly / Annual)",
    direction: "asc",
    sort: false,
    minWidth: "130px",
  },
  {
    name: "Client",
    direction: "asc",
    defaultDirection: "asc",
    sort: true,
    active: false,
    key: "company_name.keyword",
  },
  {
    name: "Created",
    direction: "desc",
    defaultDirection: "desc",
    sort: true,
    active: true,
    minWidth: "130px",
    key: "created_at",
  },
  {},
];

const intialState = {
  jobSummary: {
    results: {
      count: "",
      candidates: [
        {
          candidate_name: "",
          score: "",
          status: "'",
        },
      ],
    },

    skill: [],
  },
  jobJobEdit: {},
  jobJobEditData: {
    jobData: null,
    formikData: null,
  },
  jobCreateEditData: {
    jobData: null,
    formikData: null,
  },
  jobJobRescore: {
    data: [],
    status: "",
  },
  jobCandidateSourcing: {
    data: [],
    status: "",
  },
  judicaFilter: {
    filter: {},
    pagination: 1,
    headerData: HeaderData,
    columnName: "",
    direction: "",
    status: false,
    search: "",
  },
  jobCandidateResume: {
    file: [],
    status: "",
  },
  workFlowManagement: {},
};
const JobReducer = (state = intialState, action) => {
  switch (action.type) {
    case JOBS.jobSummary:
      return { ...state, jobSummary: action.data };
    case JOBS.jobJobEdit:
      return { ...state, jobJobEdit: action.data };
    case JOBS.jobJobEditData:
      return {
        ...state,
        jobJobEditData: {
          jobData: action.jobData,
          formikData: action.formikData,
        },
      };
    case JOBS.jobJobRescore:
      return {
        ...state,
        jobJobRescore: {
          ...state.jobJobRescore,
          [action.data.id]: {
            data: action.data.data,
            status: action.data.status,
          },
        },
      };
    case JOBS.jobCreateEditData:
      return {
        ...state,
        jobCreateEditData: {
          jobData: action.jobData,
          formikData: action.formikData,
        },
      };
    case JOBS.judicaFilter: {
      return { ...state, judicaFilter: action.data };
    }
    case JOBS.jobCandidateSourcing:
      return {
        ...state,
        jobCandidateSourcing: {
          ...state.jobCandidateSourcing,
          [action.data.id]: {
            data: action.data.data,
            status: action.data.status,
          },
        },
      };

    //Candidate Resume Upload
    case JOBS.jobCandidateResume:
      const check =
        state.jobCandidateResume.file.length === 0
          ? action
          : {
              ...state.jobCandidateResume,
              [action.data.id]: {
                file: action.data.file,
                status: action.data.status,
              },
            };
      const inProgressFiles = Object.values(check)
        .filter((item) => item && item.status === "Inprogress")
        .flatMap((item) => item.file);
      return {
        ...state,
        jobCandidateResume: {
          ...state.jobCandidateResume,
          file: inProgressFiles,
          [action.data.id]: {
            file: action.data.file,
            status: action.data.status,
          },
        },
      };

    ///workflow Management
    case JOBS.workFlowManagement:
      return {
        ...state,
        workFlowManagement: action.data,
      };
    default:
      return state;
  }
};
export default JobReducer;
